export default __webpack_public_path__ + "static/media/LilNounsReadingBoredNounGang.1e52adc4.png";